import styled from "styled-components";

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  flex: 1;
`;

export const Row = styled.div`
  display: flex;
  flex: 1;
  gap: 16px;
  align-items: center;
  justify-content: center;

  ${props => props.theme.mediaQuerie.maxWidth.sm}{
    gap: 8px;
  }
`;